<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h3 class="m-0 font-weight-bold text-primary mb-2">Categories
                    <router-link to="/admin/categories/add" class="btn btn-primary float-right"><icon icon="plus-circle" /> Add New Category</router-link>
                </h3>
                </div>
            <div v-if="deleteResponse.success != null" v-bind:class="{ 'alert-success': deleteResponse.success, 'alert-danger': !deleteResponse.success }" class="alert" role="alert">
                {{deleteResponse.message}}
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <b-table show-empty
                             striped
                             :items="filteredCategories"
                             :fields="fields">
                        <template v-slot:cell(title)="row">
                            {{ row.item.title }}
                        </template>
                        <template v-slot:cell(steps)="row">
                            <router-link :to="`/admin/categories/${row.item.id}/steps/`" class="btn btn-primary">Steps</router-link>
                        </template>
                        <template v-slot:cell(stepSequences)="row">
                            <router-link :to="`/admin/categories/${row.item.id}/step-sequences/`" class="btn btn-primary">Step Sequences</router-link>
                        </template>
                        <template v-slot:cell(modify)="row">
                            <router-link :to="`/admin/categories/${row.item.id}/edit/`" class="btn btn-warning">Modify</router-link>
                        </template>
                        <template v-slot:cell(delete)="row">
                            <button @click="enableDeleteModal(row.item)" class="btn btn-danger">Delete</button>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <modal title="Delete Confirmation" :body="modalBody" button="Delete" @action="deleteCategory(modalCategoryId)" v-if="showModal" @close="showModal = false"></modal>
    </div>
</template>

<script>
import Modal from './../../misc/Modal.vue';
export default {
    components: {
            modal: Modal
    },
    data() {
        return {
            categories: [],
            currentPage: 1,
            totalCategories: 0,
            totalPages: 1,
            deleteResponse: {},
            modalBody: null,
            showModal: false,
            modalCategoryId: null
        }
    },
    computed: {
        fields() {
            return [
                { key: 'title', label: 'Title', sortable: true },
                { key: 'steps', label: 'Steps', tdClass: 'fit'},
                { key: 'stepSequences', label: 'Step Sequences', tdClass: 'fit'},
                { key: 'modify', label: 'Modify', tdClass: 'fit' },
                { key: 'delete', label: 'Delete', tdClass: 'fit' },
            ]
        },
        modalTitle() {
            return this.$t('DELETE_CONFIRMATION')
        },
        filteredCategories() {
            try {
                let self = this;
                return this.categories.filter(function (obj) {
                    return obj.languageId == self.$store.getters.selectedLanguage.id;
                });
            }
            catch {
                return [];
            }
        }
    },
    methods: {
        enableDeleteModal: function(category){
            this.modalBody = "Select 'Delete' below if you are sure you want to delete the Category " + category.title + ' with title ' + category.title;
            this.modalCategoryId = category.id;
            this.showModal = true;
        },
        deleteCategory: function(categoryId) {
            let self = this;
            this.$http.delete('/api/categories/delete/' + categoryId)
            .then(response => {
                var tempDeleteResponse = response.data;
                tempDeleteResponse.id = categoryId;
                self.deleteResponse = tempDeleteResponse;
                
            })
            .catch(error => {
                console.log(error);
            })
        },
        loadCategories: function() {
            let self = this;
            this.$http.get('/api/categories/get-all')
            .then(response => {
                self.categories = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        loadTotalCategoriesCount: function () {
            let self = this;
            this.$http.get('/api/categories/count')
            .then(response => {
                self.totalCategories = response.data;
                self.totalPages = parseInt(self.totalCategories/10) + 1;
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    mounted: function() {
        if (typeof(this.$route.query.p) == 'undefined') {
            this.currentPage = 1;
        }
        else {
            this.currentPage = this.$route.query.p;
        }
        this.loadCategories();
    },
    watch: {
        deleteResponse: function(val){
            if(val.success === true)
            {
                // get index of object with id: val.id
                var removeIndex = this.categories.map(function(item) { return item.id; }).indexOf(val.id);
                // remove object
                this.categories.splice(removeIndex, 1);
            }
            setTimeout(() => {this.deleteResponse.success = null}, 3000)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>